import { apiGet, apiPatch } from './client';
import type { ProspectusExposureType, ProspectusExposureTypeBatchRequest } from '../types/ProspectusExposureType';

export function getProspectusExposureTypes(): Promise<ProspectusExposureType[]> {
  return apiGet<ProspectusExposureType[]>('/api/prospectus-exposure-types');
}

export function saveBatchProspectusExposureTypes(added: ProspectusExposureType[], modified: ProspectusExposureType[], deletedIds: number[]): Promise<ProspectusExposureType[]> {
  return apiPatch<ProspectusExposureTypeBatchRequest, ProspectusExposureType[]>('/api/prospectus-exposure-types/batch', { added, modified, deleted: deletedIds });
}
